import type { CheckBoxEventValue } from '@interstate/components/CheckBox';
import { CheckBox } from '@interstate/components/CheckBox';
import type { InterstateOnChangeCallback } from '@interstate/components/InterstateEvents';
import { kebabCase } from '@makemydeal/dr-common-utils';
import * as offerReduxActionCreators from '@makemydeal/dr-dash-store/actions/offerRedux';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as paymentInputActionCreators from '@makemydeal/dr-dash-store/actions/paymentInput';
import { useDispatch, useSelector } from 'react-redux';
import { TARGET_OUT_OF_POCKET } from '../../constants';
import type { FC } from 'react';

type IsTargetOutOfPocketProps = {
    hasAdjustmentInputError?: boolean;
    disabled?: boolean;
};

export const IsTargetOutOfPocket: FC<IsTargetOutOfPocketProps> = ({
    disabled,
    hasAdjustmentInputError
}: IsTargetOutOfPocketProps) => {
    const dispatch = useDispatch();
    const isTargetOutOfPocket = useSelector(offerReduxSelectors.getIsTargetOutOfPocket);

    const handleChange: InterstateOnChangeCallback<CheckBoxEventValue> = (ev) => {
        const checked = ev.target.value.checked;

        dispatch(offerReduxActionCreators.updateIsTargetOutOfPocket(checked, false));

        if (checked) {
            dispatch(paymentInputActionCreators.updateDownPayment(0));
        }
    };

    return (
        <CheckBox
            sx={{
                alignSelf: hasAdjustmentInputError ? 'center' : 'end',
                marginBottom: '6px',
                '& label': {
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '0 !important'
                },
                '& label > span:first-of-type': { top: 0, flexShrink: 0 },
                '& label > span:nth-child(2)': { fontSize: '14px', whiteSpace: 'nowrap' }
            }}
            label={TARGET_OUT_OF_POCKET}
            name={kebabCase(TARGET_OUT_OF_POCKET)}
            data-testid={kebabCase(TARGET_OUT_OF_POCKET)}
            onChange={handleChange}
            disabled={disabled}
            checked={isTargetOutOfPocket}
            value="1"
        />
    );
};

export default IsTargetOutOfPocket;
